import { useDebounce } from '../../hooks/useDebounce';
import { Input } from '../Input';

interface DeliveryCommentProps {
  t: any;
  handleAddCommentToDelivery: (comment: string) => void;
  isEdit?: boolean;
  comment?: string;
}

const DeliveryComment: React.FC<DeliveryCommentProps> = (props) => {
  const { t, handleAddCommentToDelivery, comment } = props;

  const debouncedSetComment = useDebounce(handleAddCommentToDelivery, 1000);

  return (
    <div className="py-0-5 flex items-end gap-2-0">
      <div className="flex-1 ">
        <p className="text-left mb-0-5 text-body1 md:text-1-4 font-md">
          {t('inventory.comment')}
        </p>
        <Input
          value={comment ?? ''}
          onChange={(key: string, value: string | number) => {
            debouncedSetComment(String(value));
          }}
        />
      </div>
    </div>
  );
};

export default DeliveryComment;
